import { render } from "./AboutView.vue?vue&type=template&id=75a9e4aa&scoped=true"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=75a9e4aa&scoped=true&lang=css"

import exportComponent from "D:\\Documents\\Development\\carnitas\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a9e4aa"]])

export default __exports__